import React, { useRef } from 'react'
import SplitText from './SplitText'
import ParallaxImage from './ParallaxImage'
import { RichText } from 'prismic-reactjs'
import ratio from '../helpers/ratio'

const SliderHomepage = ({ slides, backgroundImage }) => {

	/**
	*	Slider Year
	*/
	const sliderSlide = useRef(0)
	const sliderLength = slides.length
	const sliderTitles = useRef([])
	const sliderTexts = useRef([])
	const progressCurrentsEl = useRef(null)
	const progressLineEl = useRef(null)
	const sliderChangeSlide = dir => {
		// Title text and index
		const newIndex = sliderSlide.current + dir
		sliderTitles.current[sliderSlide.current].classList.remove('current')
		sliderTexts.current[sliderSlide.current].classList.remove('current')
		if (newIndex >= 0 && newIndex < sliderLength) {
			sliderSlide.current = newIndex
		} else if (newIndex < 0) {
			sliderSlide.current = sliderLength - 1
		} else if (newIndex >= sliderLength) {
			sliderSlide.current = 0
		}
		sliderTitles.current[sliderSlide.current].classList.add('current')
		sliderTexts.current[sliderSlide.current].classList.add('current')
		// Progress
		progressCurrentsEl.current.style.transform = `translate3d(0, ${ratio(-2.4) * sliderSlide.current}vw, 0)`
		progressLineEl.current.style.transform = `scaleY(${(1 / sliderLength) * (sliderSlide.current + 1)})`
	}

	return (
		<div className="SliderHomepage">
			<ParallaxImage
				className="SliderHomepage__Background"
				alt={backgroundImage.alt}
				src={backgroundImage.fluid.src}
				srcSet={backgroundImage.fluid.srcSet}
			/>
			<div className="SliderHomepage__Container">
				<div className="SliderHomepage__Titles">
					{slides.map((slide, index) => (
						<div
							className={`SliderHomepage__Title h3 ${index === 0 ? 'current' : ''}`}
							key={`slider-homepage-title-${index}`}
							ref={ref => sliderTitles.current[index] = ref}
						>
							<SplitText hasMask>
								<RichText render={slide.title.richText}/>
							</SplitText>
						</div>
					))}
				</div>
				<div className="SliderHomepage__Border"></div>
				<div className="SliderHomepage__Texts">
					{slides.map((slide, index) => (
						<div
							className={`SliderHomepage__Text bodySans ${index === 0 ? 'current' : ''}`}
							key={`slider-homepage-text-${index}`}
							ref={ref => sliderTexts.current[index] = ref}
						>
							<RichText render={slide.text.richText}/>
						</div>
					))}
				</div>
				<div className="SliderHomepage__Arrows">
					<div
						className="SliderHomepage__Arrow SliderHomepage__Arrow--Left"
						onClick={() => sliderChangeSlide(-1)}
					>
						<svg viewBox="0 0 15 10" fill="none">
							<path d="M15 5L1.5 5M1.5 5L5.79032 1M1.5 5L5.79032 9" stroke="#EAE7DD"/>
						</svg>
					</div>
					<div
						className="SliderHomepage__Arrow SliderHomepage__Arrow--Right"
						onClick={() => sliderChangeSlide(1)}
					>
						<svg viewBox="0 0 15 10" fill="none">
							<path d="M0 5L13.5 5M13.5 5L9.20968 9M13.5 5L9.20968 1" stroke="#EAE7DD"/>
						</svg>
					</div>
				</div>
			</div>
			<div className="SliderHomepage__Progress">
				<div className="SliderHomepage__CurrentsContainer">
					<div
						className="SliderHomepage__Currents"
						ref={progressCurrentsEl}
					>
						{slides.map((_, index) => (
							<div
								className="SliderHomepage__Current"
								key={`slider-homepage-progress-current-${index}`}
							>
								{index + 1 < 10 ? '0' + (index + 1) : index + 1}
							</div>
						))}
					</div>
				</div>
				<div className="SliderHomepage__LineContainer">
					<div className="SliderHomepage__Line" ref={progressLineEl}></div>
				</div>
				<div className="SliderHomepage__Max">
					{slides.length < 10 ? '0' + slides.length : slides.length}
				</div>
			</div>
		</div>
	)
}

export default SliderHomepage